import { render, staticRenderFns } from "./EditBrandingForm.vue?vue&type=template&id=040dcd86&"
import script from "./EditBrandingForm.vue?vue&type=script&lang=ts&"
export * from "./EditBrandingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports